import React from 'react';

import { Report } from 'src/components';
import { useReportParams } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(_theme => ({
  page: {
    display: 'flex',
    height: '100%',
    position: 'relative',
    width: '100%',
  },
}));

export function ReportPage(): JSX.Element {
  const { classes } = useStyles();
  const { reportId } = useReportParams();

  return (
    <div className={classes.page}>
      <Report reportId={reportId} />
    </div>
  );
}
